import styled, { keyframes } from 'styled-components';
import React from 'react';
import EntityLoader from './LoadingEntity.component';
const shimmer = keyframes`
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
`;

export const SkeletionContainer = styled.main`
  display: flex;
`;

export const SkeletonTopRightContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.l};
  background-color: ${({ theme }) => theme.colors.grey5};
  flex-direction: column;
  justify-content: start;
  padding-top: 4%;
  align-items: center;
  width: 30%;
  .yellowBar {
    height: 10px;
    width: 80%;
    border-bottom: 5px solid ${({ theme }) => theme.colors.yellow3};
  }
  .skeleton-tab {
    width: 80%; /* Default width for text-like appearance */
    height: 16px; /* Height similar to text */
    background-color: ${({ theme }) => theme.colors.grey3};
    border-radius: ${({ theme }) => theme.borderRadius};
    background: linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%);
    background-size: 200% 100%;
    animation: ${shimmer} 1.5s infinite;
    margin-bottom: ${({ theme }) => theme.spacing.xxs};
  }
  .skeleton-tab.short {
    width: 40%;
  }
  .skeleton-tab.medium {
    width: 60%;
  }
  .skeleton-tab.long {
    width: 80%;
  }
  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100vh;
  }
`;
export const SkeletonTopTab = styled.div`
  background-color: ${({ theme }) => theme.colors.grey4};
  display: flex;
  justify-content: space-between;
  height: 80px;
`;
export const SkeletonCourseContainer = styled.div`
  height: auto;
  /* border: 2px solid orange; */
  width: 70%;
  display: flex;
  flex-direction: column;
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const HomepageLoading = () => {
  return (
    <SkeletionContainer>
      <SkeletonTopRightContainer>
        <div className="skeleton-tab medium"></div>
        <div className="skeleton-tab short"></div>
        <div className="yellowBar"></div>
        <div className="skeleton-tab long"></div>
        <div className="skeleton-tab long"></div>
        <div className="skeleton-tab long"></div>
        <div className="skeleton-tab long"></div>
      </SkeletonTopRightContainer>
      <SkeletonCourseContainer>
        <SkeletonTopTab>
          <div className="skeleton-tab short"></div>
          <div className="skeleton-tab short"></div>
          <div className="skeleton-tab short"></div>
        </SkeletonTopTab>
        <div style={{ padding: '1rem' }}>
          <EntityLoader />
        </div>
      </SkeletonCourseContainer>
    </SkeletionContainer>
  );
};

export default HomepageLoading;
